import { Viewer } from '@react-pdf-viewer/core'
import { defaultLayoutPlugin } from '@react-pdf-viewer/default-layout'
import '@react-pdf-viewer/core/lib/styles/index.css'
import '@react-pdf-viewer/default-layout/lib/styles/index.css'
import { GlobalWorkerOptions } from 'pdfjs-dist'

export const PdfViewer = ({ file }) => {
  // 初始化默认布局插件
  const defaultLayoutPluginInstance = defaultLayoutPlugin()
  
  // 设置 PDF.js worker 路径
  GlobalWorkerOptions.workerSrc = new URL(
    'pdfjs-dist/build/pdf.worker.min.js',
    import.meta.url,
  ).toString();
  return (
    <>
      <h2 className="text-xl font-bold p-8 pb-4">{file?.title}</h2>
      <div className="card bg-base-100 shadow-xl">
        <div className="card-body p-0">
          <div className="h-[90vh]">
            <Viewer
              fileUrl={file?.url}
              plugins={[defaultLayoutPluginInstance]}
              theme={{
                theme: 'auto' // 自动适配深色/浅色模式 [[7]]
              }}
              renderLoader={() => (
                <div className="flex h-full items-center justify-center">
                  <span className="loading loading-spinner loading-lg text-primary"></span>
                </div>
              )}
            />
          </div>
        </div>
      </div>
    </>
  )
}